export default __webpack_public_path__ + "static/media/Login_Screen.65b788cb.png";